"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeString = exports.encodeString = exports.stringReplace = exports.generatePassword = exports.isExactSame = exports.slugify = exports.removeSpecialChars = exports.miniId = exports.selectWith = void 0;
const common_1 = require("./common");
const selectWith = (args) => {
    return JSON.stringify(args);
};
exports.selectWith = selectWith;
const miniId = (len = 5) => {
    return Math.random()
        .toString(36)
        .slice(len <= 10 ? -len : -10);
};
exports.miniId = miniId;
const removeSpecialChars = (str) => {
    return str.replace(/[^a-zA-Z0-9 ]/g, '').trim();
};
exports.removeSpecialChars = removeSpecialChars;
const slugify = (str) => {
    return (0, exports.removeSpecialChars)(str)
        .toLowerCase()
        .split(' ')
        .filter((a) => a)
        .map((a) => a.trim())
        .join('-');
};
exports.slugify = slugify;
const isExactSame = (value1, value2) => {
    return JSON.stringify(value1) === JSON.stringify(value2);
};
exports.isExactSame = isExactSame;
const generatePassword = (config = {}) => {
    let { length = 8, chars = true, numbers = true, symbols = false, } = config;
    const _numbers = '0123456789', _symbols = '!@#$%^&*()_+><{};:.,', _chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    let password = '', sourceString = '';
    if (chars)
        sourceString += _chars;
    if (numbers)
        sourceString += _numbers;
    if (symbols)
        sourceString += _symbols;
    for (var i = 0, n = sourceString.length; i < length; ++i) {
        password += sourceString.charAt(Math.floor(Math.random() * n));
    }
    return password;
};
exports.generatePassword = generatePassword;
const stringReplace = (string, start, replacement, end = string.length) => {
    return string.substring(0, start) + replacement + string.substring(end);
};
exports.stringReplace = stringReplace;
/** Encode string to base64 */
const encodeString = (str) => {
    if (!(0, common_1.hasWindow)())
        return str;
    const _unescape = window.unescape || window.decodeURI;
    try {
        return window.btoa(_unescape(encodeURIComponent(str)));
    }
    catch (_a) {
        return str;
    }
};
exports.encodeString = encodeString;
/** Decode base64 to string */
const decodeString = (encoded) => {
    if (!(0, common_1.hasWindow)())
        return encoded;
    const _escape = window.escape || window.encodeURI;
    try {
        return decodeURIComponent(_escape(window.atob(encoded)));
    }
    catch (_a) {
        return encoded;
    }
};
exports.decodeString = decodeString;
